<template>
    <div class="account-plan">

        <div class="title">
            Kontoplan
        </div>

        <!--<p>
            <br>
            Tryk enter for at opdatere budgettet på en konto.
            <br><br>
        </p>-->

        <div align="right" style="cursor:pointer;margin-bottom:15px;" @click="showEmptyAccounts = !showEmptyAccounts">
            <span v-if="!showEmptyAccounts">Vis konti uden bevægelse</span>
            <span v-else>Skjul konti uden bevægelse</span>
        </div>

        <div class="accounts" v-if="!loading && accounts && accountCategories">
            <div class="account bold">
                <div class="number">Konto</div>
                <div class="name">Navn</div>
                <div class="value">Bogført i perioden</div>
                <!--<div class="budget">Budget</div>-->
                <div class="category">Hovedkonto</div>
                <div class="show">Vis/skjul</div>
            </div>
            <div class="account" v-for="account in filteredAccounts" :key="account.uuid">
                <div class="number">
                    {{ account.account_number }}
                </div>
                <div class="name">
                    {{ account.name }}
                </div>
                <div class="value">
                    {{ account.entries_total | currency }}
                </div>
                <!--<div class="budget">
                    <input
                        type="number" v-model="account.budget"
                        step="1"
                        pattern="\d*"
                        @keydown.enter="updateAccount(account, account.category.uuid)"
                    />
                </div>-->
                <div class="category">
                    <select v-model="account.category.uuid" @change="updateAccount(account, $event)">
                        <option :value="accountCategory.uuid" v-for="accountCategory in accountCategories" :key="accountCategory.uuid">
                            {{ accountCategory.name }}
                        </option>
                    </select>
                </div>
                <div class="show">
                    <input type="checkbox" v-model="account.show" @change="toggleAccount(account)" />
                    &nbsp;
                    <span v-if="account.show">
                        Synlig
                    </span>
                    <span v-else>
                        Skjult
                    </span>
                </div>
            </div>
        </div>

        <box-loading height="350" v-else />

    </div>
</template>

<style lang="scss" scoped>
@import "../../../styles/vars.scss";

    .accounts {
        background: $color--white;
        padding: $padding--small;
        box-shadow: $boxshadow--creative;
        border-radius: $borderradius--main;

        .account {
            display: flex;
            align-items: center;
            // justify-content: space-between;
            padding: ($margin--small / 2) 0;
            
            &:not(:first-of-type):not(:last-of-type) {
                border-bottom: 1px solid rgba(0, 0, 0, 0.15);
            }

            &.bold {
                font-weight: 600;
            }

            input, select {
                background: #fff;
            }

            .number {
                flex: 0 0 10%;
                font-weight: 600;
            }

            .name {
                flex: 0 0 40%;
                padding-right: $padding--small;
            }

            .value {
                flex: 0 0 20%;
            }

            .budget {
                flex: 0 0 20%;
            }

            .category {
                flex: 0 0 20%;
                padding-right: $padding--small;
            }

            .show {
                flex: 0 0 10%;
            }

            .budget input,
            .category select {
                padding: 4px 10px;
                border: 1px solid rgba(0, 0, 0, 0.15);
                box-sizing: border-box;
                border-radius: $borderradius--main;
                cursor: pointer;
            }

            .budget input {
                width: calc(100% - 15px);
            }

            .category select {
                width: 100%;
            }

        }
    }

</style>

<script>
import * as economyService from '@/services/economyService'

export default {
    data () {
        return {
            showEmptyAccounts: false,
            loading: true,
            accounts: [],
            accountCategories: null
        }
    },
    created () {
        this.getAccountCategories()
        this.getAccounts()
    },
    methods: {
        getAccountCategories () {
            let params = {}
            economyService.accountCategories(params, (response) => {
                this.accountCategories = response.data
            }, (err) => {
                console.log(err)
            })
        },
        getAccounts () {
            this.loading = true
            this.accounts = []
            let params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            }
            economyService.accounts(params, (response) => {
                this.accounts = response.data
                this.loading = false
            }, (err) => {
                console.log(err)
                this.loading = false
            })
        },
        updateAccount (account, event) {
            if (this.$auth.user().company.demo_company && this.$auth.user().roles[0].name !== 'super-admin') {
                alert('Det er ikke muligt at ændre denne indstilling i demo-versionen.')
                return
            }
            let body = {
                budget: account.budget,
                account_category_uuid: event
            }
            if (event.target) {
                body.account_category_uuid = event.target.value
            }
            economyService.updateAccount(account.uuid, body, (response) => {
                this.$toastr('success', 'Kontoen blev opdateret', 'Sådan!')
            })
        },
        toggleAccount (account) {
            if (this.$auth.user().company.demo_company && this.$auth.user().roles[0].name !== 'super-admin') {
                alert('Det er ikke muligt at ændre denne indstilling i demo-versionen.')
                return
            }
            let body = {
                show: account.show
            }
            economyService.updateAccount(account.uuid, body, (response) => {
                this.$toastr('success', 'Kontoen blev opdateret', 'Sådan!')
            })
        }
    },
    computed: {
        filteredAccounts () {
            if (this.accounts) {
                let accounts = []
                this.accounts.forEach((account) => {
                    if (this.showEmptyAccounts) {
                        accounts.push(account)
                    } else {
                        if (account.entries_total && account.entries_total !== 0 && account.entries_total !== '0' && account.entries_total !== '0.00') {
                            accounts.push(account)
                        }
                    }
                })
                return accounts
            }
        },
        globalParams () {
            let startDate = this.$store.getters.getStartDate
            let endDate = this.$store.getters.getEndDate
            return startDate + endDate
        }
    },
    watch: {
        globalParams: function () {
            this.getAccounts()
        }
    }
}
</script>



// WEBPACK FOOTER //
// accountPlan.vue?55ed0eb8